import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from './locales/en.json';
import es from './locales/es.json';
import uk from './locales/uk.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import br from './locales/br.json';
import it from './locales/it.json';
import ru from './locales/ru.json';
//import metas from "./locales/metas.json";

export const defaultNamespace = 'default';
export const defaultLanguage = 'en';

i18n
    //.use(backend)
    .use(initReactI18next)
    .init({
        defaultNS: 'translation',
        ns: ['translation'],
        resources: {
            en: en,
            es: es,
            uk: uk,
            fr: fr,
            de: de,
            br: br,
            it: it,
            ru: ru,
           //metas: metas,
        },
        lng: defaultLanguage,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    })

export default i18n;